import { render, staticRenderFns } from "./AboutStudy.vue?vue&type=template&id=4daf1490&scoped=true"
import script from "./AboutStudy.vue?vue&type=script&lang=js"
export * from "./AboutStudy.vue?vue&type=script&lang=js"
import style0 from "./AboutStudy.vue?vue&type=style&index=0&id=4daf1490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daf1490",
  null
  
)

export default component.exports